import * as React from 'react'

import { MobXProviderContext } from 'mobx-react'

import TagsStore from '~/client/src/shared/stores/domain/Tags.store'

export function useTagsStore(): TagsStore {
  const stores = React.useContext(MobXProviderContext) as {
    tagsStore: TagsStore
  }
  return stores.tagsStore
}
